// 获取code方法 在js中不建议使用route.query.code方式

/**
     * 获取路径参数code
     */
const getUrlCodeParam = (name) => {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.href) || [, ""])[1].replace(/\+/g, '%20')) || null
}
export const getLoginCode = () => {
    const ua = navigator.userAgent.toLowerCase();
    // 判断是否在微信内部调用 ：/micromessenger/.test(ua)
    if (/micromessenger/.test(ua)) {
        // 这里是通过getUrlCodeParam('code')方法处理ulr中的 code
        const code = getUrlCodeParam('code')
        // 这里是有code走这里
        if (code) {
            console.log("返回的code数据");
            console.log(code);
            return code;
        } else {
            // 如果没用code 我们就走这里
            const redirect_url = encodeURIComponent(window.location.href);
            // 这里是定义的appid,可以通过配置获取，也可以写死在这里；
            const app_id = "wx2a1e0d328ba08e92";
            // 这里是默认方法
            const url =
                "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
                app_id +
                "&redirect_uri=" +
                redirect_url +
                "&response_type=code&scope=snsapi_base&state=1#wechat_redirect";
            window.location.href = url;
        }
    } else {
        console.error("不在微信环境内");
    }
};

